import { PLANN3R_COLOR } from '../../constants'
import { SET_FOOTER_COLORS,
  SHOW_FOOTER,
  SHOW_HEADER,
  SHOW_NAVLINKS,
  SHOW_PLAN_BUTTON } from './actions'
import { GeneralActionType, GeneralStore } from './types'

import logoBlue from '../../assets/img/logoBlue.png'

export const DEFAULT_TIMEZONE = 'Europe/London'

const initialState: GeneralStore = {
  timeZone: DEFAULT_TIMEZONE,
  header: {
    show: true,
    showPlanButton: true,
    showNavlinks: true,
    logo: logoBlue,
    colors: {
      primary: PLANN3R_COLOR,
      secondary: '#FFFFFF',
    },
  },
  footer: {
    show: true,
    logo: logoBlue,
    colors: {
      primary: PLANN3R_COLOR,
      secondary: '#FFFFFF',
    },
  },
}

export const reducer = (state = initialState, action: GeneralActionType): GeneralStore => {
  switch (action.type) {
    case SHOW_HEADER:
      return {
        ...state,
        header: Object.assign({}, state.header, { show: action.show }),
      }

    case SHOW_PLAN_BUTTON:
      return {
        ...state,
        header: Object.assign({}, state.header, {
          showPlanButton: action.show,
        }),
      }

    case SHOW_NAVLINKS:
      return {
        ...state,
        header: Object.assign({}, state.header, { showNavlinks: action.show }),
      }

    case SHOW_FOOTER:
      return {
        ...state,
        footer: Object.assign({}, state.footer, { show: action.show }),
      }

    case SET_FOOTER_COLORS:
      return {
        ...state,
        footer: Object.assign({}, state.footer, { colors: action.colors }),
      }

    default:
      return state
  }
}
